import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

import { createSelector } from "reselect";
import { currentContactSelector, contactsInListSelector } from "../contacts/Selectors";
import { padChatMessagesWithMarker, isMessagePaddedWithMarker } from "./messagesWithMarker";
export var currentContactMessageIdsSelector = createSelector(currentContactSelector, function (currentContact) {
  return currentContact ? currentContact.messageIds : [];
});
export var allMessagesSelector = function allMessagesSelector(state) {
  return state.message.messages;
};
export var allMessageDraftsSelector = function allMessageDraftsSelector(state) {
  return state.message.messageDrafts;
};
export var currentContactMessagesWithMarkerSelector = createSelector(currentContactMessageIdsSelector, allMessagesSelector, function (messageIds, messages) {
  var msgs = messageIds.map(function (id) {
    return messages[id];
  }).filter(function (m) {
    return isMessagePaddedWithMarker(m);
  });
  return padChatMessagesWithMarker(msgs);
});
export var currentContactDraftSelector = createSelector(currentContactSelector, allMessageDraftsSelector, function (currentContact, allMessageDrafts) {
  return currentContact ? allMessageDrafts[currentContact.chatId.encode()] : undefined;
});
export var lastMessagesSelector = createSelector(contactsInListSelector, allMessagesSelector, function (contacts, messages) {
  var e_1, _a;

  var res = {};

  try {
    for (var contacts_1 = __values(contacts), contacts_1_1 = contacts_1.next(); !contacts_1_1.done; contacts_1_1 = contacts_1.next()) {
      var c = contacts_1_1.value;
      var lastMessageId = c.messageIds[c.messageIds.length - 1];

      if (lastMessageId) {
        var lastMessage = messages[lastMessageId];
        res[c.chatId.encode()] = lastMessage;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (contacts_1_1 && !contacts_1_1.done && (_a = contacts_1["return"])) _a.call(contacts_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return res;
});